import { useState, useEffect } from 'react';
import './Fete.css';
import fetePic1 from '../fete/fete (1).webp'
import fetePic2 from '../fete/fete (10).webp'
import fetePic3 from '../fete/fete (11).webp'
import fetePic4 from '../fete/fete (12).webp'
import fetePic5 from '../fete/fete (13).webp'
import fetePic6 from '../fete/fete (14).webp'
import fetePic7 from '../fete/fete (15).webp'
import fetePic8 from '../fete/fete (2).webp'
import fetePic9 from '../fete/fete (3).webp'
import fetePic10 from '../fete/fete (4).webp'
import fetePic11 from '../fete/fete (5).webp'
import fetePic12 from '../fete/fete (6).webp'
import fetePic13 from '../fete/fete (7).webp'
import fetePic14 from '../fete/fete (8).webp'
import fetePic15 from '../fete/fete (9).webp'

const FetePage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // Gallery images for Session 2024-25
  const galleryImages = [
    { id: 5, src: fetePic5, alt: 'Fete Event 5' },
    { id: 4, src: fetePic4, alt: 'Fete Event 4' }, 
    { id: 3, src: fetePic3, alt: 'Fete Event 3' },
    { id: 1, src: fetePic1, alt: 'Fete Event 1' },
    { id: 6, src: fetePic6, alt: 'Fete Event 6' }, 
    { id: 2, src: fetePic2, alt: 'Fete Event 2' },
    { id: 8, src: fetePic8, alt: 'Fete Event 8' },
    { id: 9, src: fetePic9, alt: 'Fete Event 9' },
    { id: 14, src: fetePic14, alt: 'Fete Event 14' },
    { id: 7, src: fetePic7, alt: 'Fete Event 7' },
    { id: 10, src: fetePic10, alt: 'Fete Event 10' },
    { id: 12, src: fetePic12, alt: 'Fete Event 12' },
    { id: 13, src: fetePic13, alt: 'Fete Event 13' },
    { id: 15, src: fetePic15, alt: 'Fete Event 15' },
    { id: 11, src: fetePic11, alt: 'Fete Event 11' },
    
    
  ];

  useEffect(() => {
    setAllImages(galleryImages);
  }, []);

  const handleImageClick = (imageSrc) => {
    const imageIndex = galleryImages.findIndex(image => image.src === imageSrc);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex === null) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex]);

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>FETE</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Fete</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="fete-container">
        {/* Title Section */}
        <div className="fete-title-section">
          <h2>FETE</h2>
          <div className="fete-title-underline"></div>
        </div>

        {/* Session Gallery */}
        <section className="fete-gallery-section">
          
          <div className="fete-gallery">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id} 
                className={`fete-gallery-item ${index % 2 === 0 ? 'fete-left' : 'fete-right'}`}
                onClick={() => handleImageClick(image.src)}
              >
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {currentImageIndex !== null && (
        <div className="fete-modal show" onClick={(e) => {
          if (e.target.classList.contains('fete-modal')) {
            closeModal();
          }
        }}>
          <div className="fete-modal-wrapper">
            <button className="fete-modal-close" onClick={closeModal}>&times;</button>
            <button className="fete-modal-btn fete-modal-prev" onClick={prevImage}>❮</button>
            <img 
              className="fete-modal-image" 
              src={galleryImages[currentImageIndex].src} 
              alt={galleryImages[currentImageIndex].alt}
            />
            <button className="fete-modal-btn fete-modal-next" onClick={nextImage}>❯</button>
          </div>
        </div>
      )}
    </>
  );
};

export default FetePage;